/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgModule,} from '@angular/core';
import { CommonModule, NgOptimizedImage, } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


// import { SpeedDialModule } from 'primeng/speeddial';
 
import { ToastrModule } from 'ngx-toastr';

import { RouterModule } from '@angular/router';



import { CarouselModule } from 'ngx-owl-carousel-o';

import { ReadMoreModule } from '../read-more/read-more';
import { SpeedDialComponent } from '../global/speed-dial/speed-dial.component';
import {IndianPostalCodesModule} from "indian-postal-codes";
import { RatingModule } from 'primeng/rating';
import { BuyAtStoreModule } from '../global/buy-at-store/buy-at-store.module';
import { RatingPopupModule } from '../global/rating-popup/rating-popup.module';

import { ShortNamePipe } from '../pipe/short-name.pipe';
import { PhoneNumberValidatorDirective } from '../directive/phone-number-validator.directive';

import { ThousandSuffPipe } from '../pipe/thousand-suff.pipe';

import { HeaderModule } from '../global/header/header.module';
import { AlphaOnlyDirective } from '../directive/alpha-only.directive';
import { HoldDirective } from '../directive/hold.directive';
import { TypingLoaderTextComponent } from '../global/typing-loader-text/typing-loader-text.component';
import { ProductTypingBannerComponent } from '../global/product-typing-banner/product-typing-banner.component';




const THIRD_PARTY_MODULES:any[] = [
  CarouselModule,
  IndianPostalCodesModule,

];
const AB_COMPONENT:any[]=[
  // PriceRangeSliderComponent
  TypingLoaderTextComponent,
  ProductTypingBannerComponent
]
const AB_MODULES :any[] =  [
  HeaderModule,
  RouterModule,
  ReadMoreModule,
  RatingModule,
  BuyAtStoreModule,
  
  // ... other AB modules
]
const AB_PIPS :any[]=[
  ShortNamePipe,
  ThousandSuffPipe
]
@NgModule({
  declarations: [
  
    SpeedDialComponent,
    PhoneNumberValidatorDirective,
    ...AB_PIPS,
    ...AB_COMPONENT,
    AlphaOnlyDirective,
    HoldDirective,
   
  ],
  imports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
   
    ToastrModule.forRoot(),
    RatingPopupModule,
    NgOptimizedImage,
    // ...PRIMENG_MODULES,
    ...THIRD_PARTY_MODULES,
    ...AB_MODULES,

  ],
  exports:[
    CommonModule,
    PhoneNumberValidatorDirective,
    SpeedDialComponent,
    FormsModule,
    ReactiveFormsModule,

    RatingPopupModule,
    ToastrModule,

    RouterModule,
    HoldDirective,
   AlphaOnlyDirective,

    NgOptimizedImage,
    BuyAtStoreModule,

    // ...PRIMENG_MODULES,
    ...THIRD_PARTY_MODULES,
    ...AB_MODULES,
    ...AB_PIPS,
    ...AB_COMPONENT,
  ],
  providers:[ 
]
})
export class SharedModule {}
